module.exports = function () { return true }



//////////////////
// WEBPACK FOOTER
// ./~/empty-functions/returns-true.js
// module id = 25
// module chunks = 0